<template>
  <div>
    <img src="../../../assets/moblie/images/promotion.jpg" alt="" />
  </div>
</template>

<script>
export default {
  name: "PromotionPlan"
};
</script>

<style scoped>
img {
  width: 100%;
}
</style>
